import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";
import { sanitizeBlogUploadItems } from "../util/blogHelpers";

export const fetchBlogList = async () => {
  const response = await axios.get(`${API_BASE_URL}/blogs`);
  return response.data?.items || [];
};

export const fetchBlogById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/blogs/${id}`);
  return response.data;
};

export const createBlog = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/blogs`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateBlog = async (id, payload) => {
  const response = await axios.put(
    `${API_BASE_URL}/blogs/${id}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const deleteBlog = async (id) => {
  await axios.delete(`${API_BASE_URL}/blogs/${id}`, getAuthConfig());
};

export const uploadBlogsJson = async (items) => {
  const sanitizedItems = sanitizeBlogUploadItems(items);

  if (!sanitizedItems.length) {
    throw new Error("No valid blog entries found in JSON.");
  }

  const response = await axios.post(
    `${API_BASE_URL}/blogs/upload/json`,
    { items: sanitizedItems },
    getAuthConfig(),
  );

  return response.data;
};
